// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import { loadApplicationsDetails, sendApplicationContractOnEmail, sendMemberCardOnEmail } from '../../api/applications';
import { ApplicationDetails } from "../ApplicationDetails/ApplicationDetails";
import { ApplicationCard } from "../ApplicationCard/ApplicationCard";
import { TermsAndConditions } from "../TermsAndConditions/TermsAndConditions";
import cn from './Application.module.scss';

export function Application({ appNonce, applicationId }){
  const [application, setApplication] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const [isPrintingMemberCard, setIsPrintingMemberCard] = useState(false)
  const [isPrintingContract, setIsPrintingContract] = useState(false)

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const [ newApplication ] = await loadApplicationsDetails([appNonce]);
        setApplication(newApplication);
      } catch (e) {
        console.log(e);
      }
      setIsLoading(false);
    })();
  }, [appNonce]);


  const printMemberCard = () => {
    setIsPrintingMemberCard(true);
    window.addEventListener("afterprint", function resetMemberCardPrint() {
      // https://github.com/facebook/react/issues/17918 (infinite rerender fixed in react 17)
      setTimeout(() => setIsPrintingMemberCard(false), 0);
      window.removeEventListener("afterprint", resetMemberCardPrint);
    });
    setTimeout(() => window.print(), 300);
  }

  const printContract = () => {
    setIsPrintingContract(true);
    window.addEventListener("afterprint", function resetContractPrint() {
      // https://github.com/facebook/react/issues/17918 (infinite rerender fixed in react 17)
      setTimeout(() => setIsPrintingContract(false), 0);
      window.removeEventListener("afterprint", resetContractPrint);
    });
    setTimeout(() => window.print(), 300);
  }

  const sendMemberCard = async() => {
    try {
      await sendMemberCardOnEmail(applicationId);
    } catch (err) {
      console.error(err);
    }
    alert('Done');
  }

  const sendContract = async () => {
    try {
      await sendApplicationContractOnEmail(applicationId);
    } catch (err) {
      console.error(err);
    }
    alert('Done');
  }

  if (isLoading) {
    return (
      <div>
        Loading ...
      </div>
    )
  }

  if (!application) {
    return null;
  }

  return (
    <div>
      <div className={cn.printArea}>
        {isPrintingMemberCard && (<ApplicationCard application={application} />)}
        {isPrintingContract && (
          <div>
            <ApplicationDetails application={application} />
            <div className={cn.pageBreak}/>
            <TermsAndConditions />
          </div>
        )}
      </div>
      <div className={cn.content}>
        <div className={cn.header}>
          <h1>{application.member_firstname} {application.member_lastname}</h1>
        </div>
        <div className={cn.body}>
          <div className="row container">
            <div className="col-lg-6">
              <ApplicationDetails application={application} />
            </div>
            <div className="col-lg-6">
              <div className={cn.rightCol}>
                <ApplicationCard application={application} />
                <div className={cn.actions}>
                  <button onClick={printMemberCard}>Print the member card</button>
                  <button onClick={sendMemberCard}>Email the member card</button>
                  <button onClick={printContract}>Print the contract</button>
                  <a className="button button_theme" href="?print=1">Download the contract</a>
                  <button onClick={sendContract}>Email the contract</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
